import React, { useEffect, useState } from "react";
import Axios from "axios";
import { URL_LIST_ALL } from "../configs/api";
import { useSelector } from "react-redux";

export default function Calendar() {
  const { user } = useSelector((state) => state.auth);
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth();

  const [eventsByDay, setEventsByDay] = useState({});

  const firstDayOfMonth = (new Date(year, month, 1).getDay() + 6) % 7;
  const daysInMonth = new Date(year, month + 1, 0).getDate();

  const weekdays = ["T2", "T3", "T4", "T5", "T6", "T7", "CN"];

  const daysInPrevMonth = new Date(year, month, 0).getDate();

  // Tạo ngày tháng trước
  const prevMonthDays = Array.from({ length: firstDayOfMonth }, (_, i) => {
    const dPrev = daysInPrevMonth - firstDayOfMonth + i + 1;
    const yPrev = new Date(year, month - 1).getFullYear();
    const mPrev = new Date(year, month - 1).getMonth() + 1;
    return {
      day: dPrev,
      dateKey: `${yPrev}-${String(mPrev).padStart(2, "0")}-${String(
        dPrev
      ).padStart(2, "0")}`,
      isCurrentMonth: false,
    };
  });

  // Tạo ngày trong tháng này
  const currentMonthDays = Array.from({ length: daysInMonth }, (_, i) => {
    const d = i + 1;
    return {
      day: d,
      dateKey: `${year}-${String(month + 1).padStart(2, "0")}-${String(
        d
      ).padStart(2, "0")}`,
      isCurrentMonth: true,
    };
  });

  // Lấp những ngày sau
  const allDays = [...prevMonthDays, ...currentMonthDays];
  const remaining = 7 - (allDays.length % 7);
  const nextMonthDays = Array.from(
    { length: remaining < 7 ? remaining : 0 },
    (_, i) => {
      const dNext = i + 1;
      const yNext = new Date(year, month + 1).getFullYear();
      const mNext = new Date(year, month + 1).getMonth() + 1;
      return {
        day: dNext,
        dateKey: `${yNext}-${String(mNext).padStart(2, "0")}-${String(
          dNext
        ).padStart(2, "0")}`,
        isCurrentMonth: false,
      };
    }
  );

  const allDaysWithFill = [...allDays, ...nextMonthDays];

  const weeks = [];
  let temp = [...allDaysWithFill];
  while (temp.length) {
    weeks.push(temp.splice(0, 7));
  }

  useEffect(() => {
    Axios.get(URL_LIST_ALL + "calendar?status=1&month="+(month+1), user.config)
      .then((res) => {
        if (res.data.status === "success") {
          const data = res.data.data;
          const eventsMap = {};
          data.forEach((event) => {
            const dateKey = event.date_start; // "YYYY-MM-DD"
            if (!eventsMap[dateKey]) eventsMap[dateKey] = [];
            eventsMap[dateKey].push(event);
          });
          setEventsByDay(eventsMap);
        }
      })
      .catch((err) => console.log(err));
  }, [user, year, month]);

  return (
    <div className="w-100 calendar-container">
      <h5 className="text-center mb-2">
        Tháng {month + 1}/{year}
      </h5>
      <table className="table table-bordered text-center w-100 bg-white shadow-sm rounded mb-0">
        <thead>
          <tr>
            {weekdays.map((wd) => (
              <th key={wd}>{wd}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {weeks.map((week, wIndex) => (
            <tr key={wIndex}>
              {week.map((dateObj, dIndex) => {
                const { day, dateKey, isCurrentMonth } = dateObj;
                const dayEvents = eventsByDay[dateKey] || [];
                const isImportantDay = dayEvents.some((ev) => ev.important == 1);
                const isToday =
                  dateKey ===
                  `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(
                    2,
                    "0"
                  )}-${String(today.getDate()).padStart(2, "0")}`;

                return (
                  <td
                    key={dIndex}
                    className={`align-top day-item ${isToday ? "today" : ""} ${dayEvents.length
                        ? isImportantDay
                          ? "has-event bg-danger"
                          : "has-event bg-primary"
                        : ""
                      } ${!isCurrentMonth ? "other-month text-miss" : ""}`}
                  >
                    <strong>
                      {isCurrentMonth
                        ? day // Nếu là ngày trong tháng này thì chỉ hiển thị ngày
                        : `${day}/${parseInt(dateKey.split("-")[1], 10)}` // Nếu ngoài tháng này thì hiển thị d/M không số 0
                      }
                    </strong>
                    {dayEvents.length > 0 && (
                      <>
                        <span className="counter shadow-sm">{dayEvents.length}</span>
                        <div className="event-list">
                          <div className="shadow-sm rounded wrapper">
                            <span className="cheven fas fa-caret-up"></span>
                            {dayEvents.map((ev) => (
                              <div
                                key={ev.id}
                                className="p-2 text-left event-item border-bottom"
                              >
                                <p>
                                  <span className="far fa-dot-circle"></span>{" "}
                                  {ev.title}
                                </p>
                                {ev.time_start || ev.time_end ? (
                                  <p className="time-show">
                                    <i className="far fa-clock"></i>{" "}
                                    {ev.time_start ? ev.time_start.slice(0, 5) : ""}
                                    {ev.time_end ? " - " + ev.time_end.slice(0, 5) : ""}
                                  </p>
                                ) : null}
                              </div>
                            ))}
                          </div>
                        </div>
                      </>
                    )}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
